import { Component, ChangeDetectorRef , ViewEncapsulation,ElementRef, OnInit, OnDestroy, QueryList, ViewChildren, ViewChild, HostListener, AfterViewInit, OnChanges, NgZone, Output, EventEmitter } from '@angular/core';
import { SMSservice } from '../../../../core/services/sms.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '../../services/history.state.service';
import { CommmonUtil } from '../utils/common.util';
import { PatientEngagementService } from '../../services/patient-engagement.service';
import { TransactionService } from '../../services/transaction.service';
import { constant } from '../../../../constants/app.constants';
import { debounceTime, distinctUntilChanged, fromEvent, Subject, takeUntil } from 'rxjs';
import { NgbDatepicker, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../environments/environment';
import { WebPubSubService } from '../../../../services/WebPubSubService';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';import moment from 'moment';
import { ProfileService } from '../../../../services/profile.service';
import { IdentifierTypeEnum } from '../../../SecurePatientCommunication/models/chat.enum';
interface DboardCounts {
  Pending_Payments: number;
  My_Meds: number;
  Ready_to_Dispense: number;
  Refills_Due: number;
  New_Prescription: number;
}

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrl: './history.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class HistoryComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  elinkParams:any;
  elinkData:any;
  rxHistoryInfo: any[] = [];
  customRxHistory: any[] = [];
  histPayload: any;
  readyForPickup:any[] = [];
  currentIndex: number = 0;  
  mymedsLength: number = 0;
  readyForPickupLength: number = 0;
  PendingPaymentsLength: number = 0;
  newErxsCount: number = 0;
  refillsDueCount: number = 0;
  newPrescription:any[] = [];
  refillsDueRxs:any[] = [];
  stickyHeaderText: string = 'Active Meds: 0';
  activeIndex: number | null = null;
  activeSection: string = '';
  
dboardCounts: DboardCounts = {
  Pending_Payments: 0,
  My_Meds: 0,
  Ready_to_Dispense: 0,
  Refills_Due: 0,
  New_Prescription: 0
};  
  metaData: any = {};
  eLinkData: any = {};
  transcationList: any[] = [];
  transcationCount: number = 0;
  selectedTransDetails: any; 
  subScriptionStatus!:boolean;
  dashbaordCounts: any = [];
  isDatepickerOpen = false; 
  isRxStatusDropdownOpen: boolean = false;
  isDateDropdownOpen: boolean = false;
  scrollInitialized = false;
scrollSub?: any; // Subscription

  

  selRxStatusOption: string = 'All';
  selDateOption: string = 'All';
  
  rxStatusOptions: string[] = ['All', 'Billed', 'Unbilled', 'Deferred', 'Transferred', 'Transferred In', 'Transferred Out'];
  dateOptions: string[] = ['All', 'Today', 'Last One Week', 'Last 30 Days', 'Last 60 Days', 'Last 90 Days', 'Last 6 Months', 'Last 1 Year', 'Custom Date'];
  customFromDate!:any; 
  customToDate!:any;   
  isFilterMenuVisible = false;
  isBackdropVisible = false;
  isCustomDateRange:any;
  showDuplicateError: boolean = false;
  @Output() transactionListLoaded: EventEmitter<void> = new EventEmitter();

  @ViewChild('filterIcon') filterIcon!: ElementRef;   
  @ViewChild('filterMenu') filterMenu!: ElementRef;
  @ViewChild('backdrop') backdrop!: ElementRef;
  @ViewChildren('item') items!: QueryList<ElementRef>;
  @ViewChild('historyData') historyData!: ElementRef;
  @ViewChild('dateRange') dateRange!: ElementRef;
  @ViewChild('rxStatus') rxStatus!: ElementRef;
  @ViewChild('breadcrumbs', { static: false }) breadcrumbs!: ElementRef;
  @ViewChild('stickyHeader', { static: true }) stickyHeader!: ElementRef;
  @ViewChild('heightMyMeds', { static: false }) heightMyMeds!: ElementRef;
  @ViewChild('heightReadyDispense', { static: false }) heightReadyDispense!: ElementRef;
  @ViewChild('heightPrescription', { static: false }) heightPrescription!: ElementRef;
  @ViewChild('heightRefillsDue', { static: false }) heightRefillsDue!: ElementRef;
  @ViewChild('pendingPaymentsDivs', { static: false }) pendingPaymentsDivs!: ElementRef;
  @ViewChild('fromDateInput', { static: false }) fromDateInput!: ElementRef;  
  @ViewChild('toDateInput', { static: false }) toDateInput!: ElementRef;  
  
  private needScroll = false;
  private observer!: IntersectionObserver;
  noDataFound: boolean = false;
  noData_Msg: string = constant.NO_DATA_FOUND;
  showErrorPopup: boolean = false;
  currentErrorMessage: string = '';
  isCustomDate:boolean = false;
  isAuthorized:boolean = false;
  isSecurePatientComm!:boolean;
  patientID_npi:any;
  openExtenalMedsPopup: boolean = false;
  selectedDate = '2025-05-08';
  unsubscribe$: Subject<void> = new Subject();
  private boundOnClick = (event: MouseEvent) => this.onClick(event);
  isEditExternalMeds = false;
  isTransferInMed = false;
  filterData: any[] = [];
  drugSearchTerm = new Subject<string>();
  pharmacySearchTerm = new Subject<string>();
  externalRxFG!: FormGroup;
  TansferPharmacyFG : FormGroup;
  activeMedsCount: number = 0;
  historyCount: number = 0;
  sections: { [key: string]: boolean } = {
    activeMeds: false,
    history: false
  };
  currentSection: string | null = null;
  isFrmExternalMeds = true;
  drugId: any;
  drugNDC: any;
  enableSuggestions = false;
  sourcePharmacyNPI: any;
  externalRxHistory = [];
  externalHistoryId: any;
  originalRxHistory: any[] = [];
  isDeleteExternalMeds = false;
  indexToDelete: any;
  todayDate: string = new Date().toISOString().split('T')[0];
  drugName: any;
  sendInitiationSuccess = false;
  showSentRequest = false;
  orderDate: any;
  isFillDtExceeded = false;
  isDrugNotFound = false;
  isPharmacyNotFound = false;
  transferPharmacyNPI: any;
  pageSize: number = 10;
  pageNumber: number = 0;
  allReadyForPickup: any[] = [];
  hasMoreData: boolean = true;
  isFetchingReadyForPickup: boolean = false;
  drugList: any;
  pharmacyList: any;
  drugPageNumber: number = 0;
  drugPageSize: number = 20;
  hasMoreDrugSuggestions: boolean = true;
  isFetchingDrugs: boolean = false;
  latestDrugSearchTerm: string = '';
  totalDrugCount: any;
  currentSearchTerm: string ='';
  enteredPharmacyDetails: any;
  drugAfterKey: any = null;  
  constructor(
        private smsService:SMSservice,
        private stateService: StateService, 
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone,
        private commmonUtil:CommmonUtil,
        private _peServie: PatientEngagementService,
        private _profileSvc : ProfileService,
        private _transService: TransactionService,
        private _router: Router,
        private _route: ActivatedRoute,
        private webPubSubService: WebPubSubService,
        private _fb : FormBuilder
      ) { 
        this.externalRxFG = this._fb.group({
          RxNumber: [{ value: '', disabled: false }],
          DrugName: [{ value: '', disabled: false }, Validators.required],
          RefillsLeft: [{ value: null, disabled: false }],
          OrderDate: [{ value: '', disabled: false }],
          FillDate: [{ value: '', disabled: false }, Validators.required],
          ExpirationDate: [{ value: '', disabled: false }],
          SupplyDays: [{ value: '', disabled: false }],
          QtyDisp: [{ value: '', disabled: false}],
          DispensingPharmacy: [{ value: '', disabled: false }, Validators.required],
          PharmacyPhone: [{ value: '', disabled: false }, Validators.required],
          ExternNotes: [{ value: null, disabled: false }]
      });

      this.TansferPharmacyFG = this._fb.group({NCPDPID:  null,
        Remarks: null,
        Npi: [null, Validators.required],
        BusinessName:  [null, Validators.required],
        Specialty: null,
        Address: this._fb.group({
          AddressLine1: [null],
          AddressLine2: [null],
          City: [null],
          State: [null],
          ZipCode: [null],
          CountryCode: [null]
        }),
        PhoneNumbers: [],
        TenantId : null,
        tenantNPI : null
    });
      // this.stateService.activeSection$.subscribe(section => {
      //   this.activeSection = section;
      //   this.needScroll = true;
      // });
    }

ngOnInit(): void {
   if (typeof window !== 'undefined' && window.top && window.top !== window.self) {
    window.top.location.href = window.location.href;
    return;
  }

  if (localStorage.getItem('signatureId')) {
    const npi = JSON.parse(localStorage.getItem('MetaData') as string);
    const payload = { insSigTransId: localStorage.getItem('signatureId'), pharmacyNPI: npi?.pharmacyNpi };
    this._peServie.deleteSignature(payload).subscribe((res) => {
      if (res) {
        localStorage.removeItem('signatureId');
      }
    });
  }

  this.isSecurePatientComm = environment.isSecurePatientComm;
  this.metaData = JSON.parse(localStorage.getItem('MetaData') as string);
  if (this.metaData && this.isSecurePatientComm) {
    this.patientID_npi = JSON.stringify(this.metaData?.patientId) + '_' + this.metaData?.pharmacyNpi;
    this.webPubSubService.initializePatientWebSocket(this.patientID_npi)
      .catch(err => console.error('[History] WebSocket init failed (chat unavailable):', err));
  }

 this.updateDashboardCounts();
this.getPrimeRxUserId();
  this.stateService.activeSection$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((section) => {
      this.activeSection = section;
      if (section) {
        this.getPharmacyInformation();
        this.loadSectionData(section);
      }
    });
  this._route.queryParams
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(params => {
      if (params && params['message']) {
        this.currentErrorMessage = params['message'];
        this.handleError(this.currentErrorMessage);
      } else {
        this.currentErrorMessage = '';
      }
    });

  
  this.setupSearchSubscriptions(); 
}

private loadSectionData(section: string) {
  // Refresh counts on every tab switch so tab badges stay current
  this.updateDashboardCounts();

  switch (section) {
    case 'myMeds':
      this.getRxHistoryData('onLoad').then(() => {
        this.initializeScrollListenerOnce();
        this.cdr.detectChanges();
        this.adjustHeight(this.heightMyMeds);
      }).catch(err => console.error('[History] Failed to load myMeds:', err));
      break;

    case 'readyToDispense':
      this.resetReadyForPickup();
      this.getReadyForPickup().then(() => {
        this.cdr.detectChanges();
        this.adjustHeight(this.heightReadyDispense);
      }).catch(err => console.error('[History] Failed to load readyToDispense:', err));
      this.initializeScrollListenerOnce(); // for infinite scroll
      break;

    case 'newPrescription':
      this.getNewErxs().then(() => {
        this.cdr.detectChanges();
        this.adjustHeight(this.heightPrescription);
      }).catch(err => console.error('[History] Failed to load newPrescription:', err));
      break;

    case 'refillsDue':
      this.getRefillsDue().then(() => {
        this.cdr.detectChanges();
        this.adjustHeight(this.heightRefillsDue);
      }).catch(err => console.error('[History] Failed to load refillsDue:', err));
      break;

    case 'pendingPayments':
      this.getPendingTranscationList().then(() => {
        this.cdr.detectChanges();
        this.adjustHeight(this.pendingPaymentsDivs);
      }).catch(err => console.error('[History] Failed to load pendingPayments:', err));
      break;

    case 'chat':
      this._router.navigate(['/spc']);
       break;

    default:
      this._router.navigate(['/dashboard']);
  }
}

private setupSearchSubscriptions() {
  this.drugSearchTerm
    .pipe(debounceTime(800), takeUntil(this.unsubscribe$))
    .subscribe((term: string) => {
      this.latestDrugSearchTerm = term;
      if (term && term.trim().length > 2) {
        this.drugPageNumber = 0;
        this.drugAfterKey = null; 
        this.hasMoreDrugSuggestions = true;
        this.getDrugInfo(term);
      } else {
        this.filterData = [];
        this.enableSuggestions = false;
        this.isDrugNotFound = false;
        this.drugNDC = null;
      }
    });

  this.pharmacySearchTerm
    .pipe(debounceTime(800), takeUntil(this.unsubscribe$))
    .subscribe((term: string) => {
      if (term && term.trim().length > 2) {
        this.getExternalPharmacyInfo(term);
      } else {
        this.filterData = [];
      }
    });
}

private resetReadyForPickup() {
  this.pageNumber = 0;
  this.allReadyForPickup = [];
  this.readyForPickup = [];
  this.hasMoreData = true;
}

private initializeScrollListenerOnce(): void {
  if (this.scrollInitialized) return;

  const scrollableElement = document.querySelector('.mobile-common-scroll');
  if (!scrollableElement) return;

  this.scrollSub = fromEvent(scrollableElement, 'scroll')
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
      this.onScroll();

      const el = scrollableElement as HTMLElement;
      const scrollTop = el.scrollTop;
      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;

      if (scrollTop + clientHeight >= scrollHeight - 50) {
        if (this.activeSection === 'readyToDispense') {
          this.getReadyForPickup();
        }
      }
    });

  this.scrollInitialized = true;
}


  calculateCounts() {
    this.activeMedsCount = this.customRxHistory?.filter(item => item.Section === 'Active Meds').reduce((sum, item) => sum + item.eachLength, 0);
    this.historyCount = this.customRxHistory?.filter(item => item.Section === 'History').reduce((sum, item) => sum + item.eachLength, 0);
  }

  toggleSection(section: string) {
  this.currentSection = this.currentSection === section ? null : section;
  if (this.currentSection) {
    this.customRxHistory = this.originalRxHistory.filter(item => item.iterativeObject === this.currentSection);
    this.stickyHeaderText = this.customRxHistory?.[0]?.Section;
  } else {
    this.customRxHistory = [...this.originalRxHistory]; // restore all
  }
}

  goToPreviousScreen() {
  this.currentSection = null;
  this.customRxHistory = [...this.originalRxHistory];
}

  selectRxStatus(option: string, event: Event) {
    event.stopPropagation();
    this.selRxStatusOption = option;
    this.isRxStatusDropdownOpen = false;  
  }

  selectDateOption(option: string, event: Event) {
    event.stopPropagation();
    this.selDateOption = option;
    this.isDateDropdownOpen = false;
  }

  toggleRxStatusDropdown(event: Event) {
    event.stopPropagation();
    this.isRxStatusDropdownOpen = !this.isRxStatusDropdownOpen;
    this.isDateDropdownOpen = false;
  }

  toggleDateDropdown(event: Event) {
    event.stopPropagation();
    this.isDateDropdownOpen = !this.isDateDropdownOpen;
    this.isRxStatusDropdownOpen = false;
  }


  @HostListener('document:click', ['$event'])
  clickOutsideDropdown(event: MouseEvent) {
    const rxStatusDropdown = document.querySelector('.rx-status-dropdown');
    const dateDropdown = document.querySelector('.date-dropdown');
    
    if (rxStatusDropdown && !rxStatusDropdown.contains(event.target as Node)) {
      this.isRxStatusDropdownOpen = false; 
    }

    if (dateDropdown && !dateDropdown.contains(event.target as Node)) {
      this.isDateDropdownOpen = false; 
    }
  }
  
  onInputClick(fromDatepicker: any) {
    if (fromDatepicker) {
        if (this.isDatepickerOpen) {
          fromDatepicker.close();
          this.isDatepickerOpen = false;
          this.isCustomDate = false;
        } else {
          fromDatepicker.open();
          this.isDatepickerOpen = true;
          this.isCustomDate = true; 
        }
    }
  }
  
  onDateSelect(event: any, fromDatepicker: any) {
    if (event) {
        this.isCustomDate = true;
        fromDatepicker.close();
        this.isDatepickerOpen = false; 
        this.ngZone.runOutsideAngular(() => {
          requestAnimationFrame(() => {
            this.isCustomDate = false;
          });
        });  
    }
  }
  openDatepicker(fromDatepicker: any) {
    if (!this.isDatepickerOpen) {
      fromDatepicker.open();
      this.isDatepickerOpen = true; 
    }
  }
  closeDatepicker(fromDatepicker: any) {
    if (this.isDatepickerOpen) {
      fromDatepicker.close();
      this.isDatepickerOpen = false;
    }
  } 

  showError(message: string) {
    this.currentErrorMessage = message;
    this.showErrorPopup = true;
  }
  handleError(errMsg:any) {
    this.showError(errMsg);
  }
  onCloseErrorPopup() {
    this.showErrorPopup = false;
    this.resetParams();
  }
  ngAfterViewInit(): void {
    this.needScroll = true;
    document.addEventListener('click', this.boundOnClick);
    //this.initializeScrollListener(); 
    const ua = navigator.userAgent;
    const isIOS17 = /iPhone|iPad|iPod/.test(ua) && /OS 17_/.test(ua);
    if (isIOS17) {
    document.body.classList.add('ios17-fix');
  }
  } 
  resetParams(){
    this._router.navigate([], {
      queryParams: { message: null },  
      queryParamsHandling: 'merge',  
      replaceUrl: true  
    });
  }
  ngOnChanges() { 
    //this.initializeScrollListener();
  }

adjustHeight(element: ElementRef) {
   if (!element) {
    console.warn('adjustHeight called with undefined element');
    return;
  }
   const viewportHeight = window.innerHeight;
   const viewportWidth = window.innerWidth;
   const offsetTop = element.nativeElement.getBoundingClientRect().top;
   const height = viewportHeight - offsetTop;
   let finalHeight = height;

   const mobileBreakpoint = 480;
   const tabletBreakpoint = 768;
   if (viewportWidth <= mobileBreakpoint) {
    finalHeight = height;
   } else if (viewportWidth <= tabletBreakpoint) {
    finalHeight = height - 60;
   } else {
    finalHeight = height - 65;
   }

   element.nativeElement.style.height = `${finalHeight}px`;
   element.nativeElement.style.overflowY = 'auto';
}

  ngAfterViewChecked(): void {
    if (this.needScroll) {
      this.scrollActiveButtonIntoView();
      this.needScroll = false; 
    }
  }

  scrollActiveButtonIntoView(): void {
    if (this.breadcrumbs) {
      this.commmonUtil.scrollActiveButtonIntoView(this.breadcrumbs, this.activeSection);
    }
  }

  async getPharmacyInformation() {
    try{
        this.cdr.detectChanges();
        this.elinkParams =  JSON.parse(localStorage.getItem('paramsData') as string);
        this.elinkData = localStorage.getItem("eLinkData")!== 'undefined' ? JSON.parse(localStorage.getItem("eLinkData") || '{}') : {};
      } catch (error) {
        console.log(error);
    }
  }

  showSection(section: string) {
    this.activeSection = section;
    this.stateService.setActiveSection(section);
    setTimeout(() => this.scrollActiveButtonIntoView());
    if (section === 'myMeds') {
      this.initializeScrollListener();
    }
  }

  initializeScrollListener(): void {
    const scrollableElement = document.querySelector('.mobile-common-scroll'); 
    if (scrollableElement) {
     fromEvent(scrollableElement, 'scroll').pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.onScroll();

    const scrollTop = scrollableElement.scrollTop;
    const scrollHeight = scrollableElement.scrollHeight;
    const clientHeight = scrollableElement.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - 50) {
      if (this.activeSection === 'readyToDispense') {
        this.getReadyForPickup();
      }
    }
  });
    }
  }

  async getPendingTranscationList() {
    try {
          const elinkDataString = localStorage.getItem('eLinkData');
          this.elinkParams = JSON.parse(localStorage.getItem('paramsData') as string); 
          this.metaData = JSON.parse(localStorage.getItem('MetaData') as string);
          const isGuestUser = JSON.parse(localStorage.getItem('IsGuestUser') as string);      
          this.eLinkData = elinkDataString ? JSON.parse(elinkDataString) : {};
          this.noDataFound = false;
          await this.smsService.postTransaction({
            "PatientNo": isGuestUser ? JSON.stringify(this.metaData?.patientId) : JSON.stringify(this.eLinkData?.EntityId),
            "NPINo": isGuestUser ? this.metaData?.pharmacyNpi : this.elinkParams?.npi,  
          }).then((resp: any) => {
            if (resp && resp.data?.length > 0) {
                this.transcationCount = resp.data?.length;
                this.transcationList = resp.data;
                this.transactionListLoaded.emit();
            } else {
              this.noDataFound = true;
              this.transcationList = [];
            }
          });

      } catch (error) {
          console.error("Error parsing eLinkData from localStorage:", error);
      }
  }

  async goToReviewOrder(selectedTrans: any) {
    if(selectedTrans && selectedTrans?.transID){
        if (selectedTrans?.isPatientRXBucket) {
          this._peServie.getPermanentTransId(selectedTrans).subscribe({
            next: (resp: any) => {
              if (resp?.result === 'SUCCESS' && resp?.data) {
                const parsed = typeof resp?.data === 'string' ? JSON.parse(resp?.data) : resp.data;
                selectedTrans.transID = parsed?.transID;
              }
              this.navigateToReviewOrder(selectedTrans);
            },
            error: () => {
              this.navigateToReviewOrder(selectedTrans);
            }
          });
        } else {
          this.navigateToReviewOrder(selectedTrans);
        }
    } else {
      this.currentErrorMessage = constant.trans_details_MSG;
      this.handleError(this.currentErrorMessage);
      this._router.navigate(['/dashboard']);
    }
  }

  private navigateToReviewOrder(selectedTrans: any) {
    localStorage.setItem("SelectedTransId", JSON.stringify(selectedTrans?.transID));
    localStorage.setItem('selectedTransDetails', JSON.stringify(selectedTrans));
    this._transService.setSelectedTransaction(selectedTrans);
    this._router.navigate(['/revieworders']);
  }


  async getRxHistoryData(type: string = 'onLoad') {
      this.closeFilter('Clear'); 
      this.currentIndex = 0;
      this.mymedsLength = 0;
        this.histPayload = {
          "patientId": this.elinkData?.EntityId,
          "pharmacyNpi": this.elinkParams?.npi,
          "rxStatus": "all",
          "includeExternalHistory": true
        }
        if(type !== 'onLoad' && (this.selDateOption || this.selRxStatusOption)){
            const selectedDateRange = this.selDateOption;
            const selectedRxStatus = this.selRxStatusOption;
            const dateRange = this.calculateDateRange(selectedDateRange);
            
            this.histPayload = {
              ...this.histPayload,
              "fromDate": dateRange?.fromDate || undefined,
              "toDate": dateRange?.toDate || undefined,
              "rxStatus": selectedRxStatus || "all",
            };
        }
        try { 
              this.noDataFound = false;
              await this.smsService.getMyMedsHistory(this.histPayload).then(data => {
              if((data && data?.activeRxs?.length > 0) || (data && data?.rxHistory?.length > 0)){
                  const activeRxs = data?.activeRxs || [];
                  const rxHistory = data?.rxHistory || [];
                  this.mymedsLength = activeRxs?.length + rxHistory?.length;
                  this.customRxHistory = [
                    {
                      Section: 'Active Meds',
                      eachLength: activeRxs.length,
                      iterativeObject: 'activeMeds',
                      records: activeRxs.map((rx: any) => this.transformToCustomObject(rx))
                    },
                    {
                      Section: 'History',
                      eachLength: rxHistory.length,
                      iterativeObject: 'history',
                      records: rxHistory.map((rx: any) => this.transformToCustomObject(rx))
                    }
                  ];
                  this.originalRxHistory = this.customRxHistory;
                  this.customRxHistory = [...this.originalRxHistory]; // clone it for display
                  this.stickyHeaderText = (activeRxs.length > 0) ? "Active Meds: "+activeRxs.length :'';
                  this.ngZone.run(() => {
                    this.cdr.detectChanges();
                  });
                  this.initializeScrollListener();
                } else {
                  this.noDataFound = true;
                  this.stickyHeaderText = '';
                  this.customRxHistory = [];
                }
              });
            } catch (error) {
              console.error('Error fetching Rx history data', error);
            }
            this.cdr.detectChanges();
            // this.calculateCounts();
  }
  
  onScroll() {  
    this.ngZone.run(() => {
      const activeMedsSection = document.querySelector('.sec0') as HTMLElement;
      const historySection = document.querySelector('.sec1') as HTMLElement;
  
      if (!activeMedsSection || !historySection) return;
      const activeMedsRect = activeMedsSection.getBoundingClientRect();
      const historyRect = historySection.getBoundingClientRect();
      if (activeMedsRect.bottom - 200 <= 50 && this.stickyHeaderText !== `History: ${this.customRxHistory[1].eachLength}`) {
        this.stickyHeaderText = `History: ${this.customRxHistory[1].eachLength}`;
      }
      if (historyRect.top - 50 > 200 && this.stickyHeaderText !== `Active Meds: ${this.customRxHistory[0].eachLength}`) {
        this.stickyHeaderText = `Active Meds: ${this.customRxHistory[0].eachLength}`;
      }
      this.cdr.detectChanges();
    });
  }

  closeFilter(type:any): void {
    if(type === 'Clear'){
      if(this.filterMenu?.nativeElement){
          const filterMenu = this.filterMenu.nativeElement;
          const backdrop = this.backdrop.nativeElement; 
          filterMenu.style.display = 'none';
          backdrop.style.display = 'none';
      }
    } else {
      this.isCustomDate = true;
      this.ngZone.runOutsideAngular(() => {
        requestAnimationFrame(() => { 
            this.selRxStatusOption = 'All';
            this.selDateOption = 'All'; 
            this.isCustomDate = false; 
        });
      });
    }
  }

  toggleAccordion(element: ElementRef, index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
    this.items.forEach((itemElement, i) => { 
      const nativeItem = itemElement?.nativeElement;
      if(nativeItem){
        if (i === index) {
          nativeItem.classList.toggle('active'); 
        } else {
          nativeItem.classList.remove('active');
        }
      }
    }); 
  } 
  
  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {    
    if (this.filterMenu && this.backdrop && this.filterIcon) {
      const filterMenu = this.filterMenu.nativeElement;
      const backdrop = this.backdrop.nativeElement;
      const filterIcon = this.filterIcon.nativeElement; 
      if (!filterIcon.contains(event.target) && !filterMenu.contains(event.target) && !this.isCustomDate) {
        filterMenu.style.display = 'none';
        backdrop.style.display = 'none';
      }
    }
  }

  getSectionCount(section: string): number {
    return this.customRxHistory.filter(item => item.Section === section).length;
  }
  
  togglePopup() {
        const filterMenu = this.filterMenu?.nativeElement;
        const backdrop = this.backdrop?.nativeElement;
        const computedStyles = window.getComputedStyle(filterMenu);
        const display = computedStyles.getPropertyValue('display');
      if (display === 'none') {
        const icon = this.filterIcon?.nativeElement;
        const position = icon.getBoundingClientRect();
        const top = position.bottom + window.scrollY + 8;
        const left = position.left - 150;  

        filterMenu.style.display = 'block';
        filterMenu.style.top = `${top}px`;
        filterMenu.style.left = `${left}px`;
        backdrop.style.display = 'block';
      } else { 
        filterMenu.style.display = 'none';
        backdrop.style.display = 'none';
      }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event):void {
    if(this.filterIcon?.nativeElement && this.filterMenu?.nativeElement){
      const icon = this.filterIcon?.nativeElement;
      const position = icon.getBoundingClientRect();
      const top = position.bottom + window.scrollY + 8;
      const left = position.left - 150;  

      const filterMenu = this.filterMenu?.nativeElement;
      filterMenu.style.top = `${top}px`;
      filterMenu.style.left = `${left}px`;
    }
    if(this.activeSection === 'myMeds'){
      this.adjustHeight(this.heightMyMeds);
    } else if(this.activeSection === 'readyToDispense'){
      this.adjustHeight(this.heightReadyDispense);
    } else if (this.activeSection === 'newPrescription') {
      this.adjustHeight(this.heightPrescription); 
    } else if (this.activeSection === 'refillsDue') {
      this.adjustHeight(this.heightRefillsDue); 
    } else if (this.activeSection === 'pendingPayments') {
      this.adjustHeight(this.pendingPaymentsDivs); 
    }
  }

  @HostListener('document:mousewheel', ['$event'])
  onWindowScroll() {
    this.initializeScrollListener();
  }

  transformToCustomObject(activeRx: any) {
    const statusMapping: { [key: number]: string } = {
      1: 'Unbilled',
      2: 'Billed',
      3: 'TransferIn',
      4: 'TransferOut',
      6: 'Deferred'
    };

    const statusId = activeRx?.rxBill?.statusId as keyof typeof statusMapping;
    const RxstatusId = statusMapping[statusId] || 'Unknown';
    const rxDisplay=this.checkIsPartialFill(activeRx?.prescReFill,activeRx?.prescription,activeRx?.rxType)
    ? activeRx.prescription.prescNum + ' - '+ activeRx?.prescReFill.reFillNum + ' - ' + activeRx.prescReFill.partialFillNo
    : activeRx.prescription.prescNum + ' - '+ activeRx?.prescReFill.reFillNum;

    return {
      index: this.currentIndex++,
      Rx: activeRx?.prescription?.prescNum,
      reFill_Num: activeRx?.prescReFill?.reFillNum,
      partialFill_No:activeRx?.prescReFill.partialFillNo,
      Fill_Date: activeRx?.prescReFill?.fillDtTm,
      Drug_Name: activeRx?.isExternalPrescription ? activeRx?.drug?.drugname : `${activeRx?.drug?.drugname} ${activeRx?.drug?.strength} ${activeRx?.drug?.drugunit} ${activeRx?.drug?.drugformname}`,
      Qty: `${activeRx?.prescReFill?.dispQty}`,
      Days_Supply: activeRx?.prescReFill?.supplyDays ? `${activeRx?.prescReFill?.supplyDays}` : null,
      Qty_Disp: activeRx?.prescReFill?.dispQty ? `${activeRx?.prescReFill?.dispQty}` : null,
      Rx_Status: RxstatusId,
      Prescriber_name: `${activeRx?.prescriber?.prescriberlastname} ${activeRx?.prescriber?.prescriberfirstname}`,
      Insurance: `${activeRx?.insuranceInfo?.insuCarrier?.binNum} ${(activeRx?.insuranceInfo?.insuPlan?.processorNum !== null ) ? '/ '+activeRx?.insuranceInfo?.insuPlan?.processorNum : '--' }`,
      Cpay_Amt: activeRx?.prescReFill?.totalCopay,
      isExternalPrescription: activeRx?.isExternalPrescription,
      Refil_Left: activeRx?.prescReFill?.refillsLeft,
      Order_Date: activeRx?.prescReFill?.orderDtTm,
      Expiration_Date : activeRx?.prescReFill?.expDt,
      Source_PharmacyName: activeRx?.sourcePharmacyName,
      Source_Pharmacy_PhoneNumber : activeRx?.sourcePharmacyPhoneNumber,
      Notes: activeRx?.notes,
      externalHistoryId: activeRx?.externalHistoryId,
      DrugId : activeRx?.drugId,
      isTransferRequestSentFromMyPrimeRx : activeRx?.isTransferRequestSentFromMyPrimeRx,
      Source_Pharmacy_NPI : activeRx?.sourcePharmacyNPI,
      RxDisplay: rxDisplay,
      isCash : activeRx?.insuranceInfo?.insurance?.isCash
    };
  }
  async getReadyForPickup(){
      this.readyForPickupLength = 0;
      if (!this.hasMoreData || this.isFetchingReadyForPickup) return;
       this.isFetchingReadyForPickup = true;
      this.histPayload = {
        "patientId": this.elinkData?.EntityId,
        "pharmacyNpi": this.elinkParams?.npi,
        "PageSize": this.pageSize,
        "PageNumber": this.pageNumber * this.pageSize,
      }
      this.noDataFound = false;
      await this.smsService.getReadyForPickup(this.histPayload).then(data => {
        this.isFetchingReadyForPickup = false;
        if(data && data?.readyForPickupRxs?.length > 0){
          const readyPickRxs = data.readyForPickupRxs || [];
          this.readyForPickupLength = readyPickRxs?.length;
          const combinedData = [...readyPickRxs];
          const mapped = combinedData.map(item=>this.readyForPickupToCustomObject(item));
          this.allReadyForPickup = [...this.allReadyForPickup, ...mapped];
          this.readyForPickup = [...this.allReadyForPickup];
           this.pageNumber = this.pageNumber + 1;
        } else {
         if (!this.pageNumber) {
        this.noDataFound = true;
        this.readyForPickup = [];
      }
      this.hasMoreData = false;
        }
    }).catch(() => {
    this.isFetchingReadyForPickup = false;
  });
  }

  readyForPickupToCustomObject(readyPickRx: any): any { 
    const rxDisplay=this.checkIsPartialFill(readyPickRx?.prescReFill,readyPickRx?.prescription,readyPickRx?.rxType)
    ? readyPickRx.prescription.prescNum + ' - '+ readyPickRx?.prescReFill.reFillNum + ' - ' + readyPickRx.prescReFill.partialFillNo
    : readyPickRx.prescription.prescNum + ' - '+ readyPickRx?.prescReFill.reFillNum;
    return {
      Rx: readyPickRx?.prescription?.prescNum,
      Drug_Name: `${readyPickRx?.drug?.drugname} ${readyPickRx?.drug?.strength} ${readyPickRx?.drug?.drugunit} ${readyPickRx?.drug?.drugformname}`,
      Prescriber_name: `${readyPickRx?.prescriber?.prescriberlastname} ${readyPickRx?.prescriber?.prescriberfirstname}`,
      Qty: `${readyPickRx?.prescReFill?.dispQty}`,
      Days_Supply: `${readyPickRx?.prescReFill?.supplyDays}`,
      Refil_Left: readyPickRx?.prescReFill?.refillsLeft,
      Fill_Date: readyPickRx?.prescReFill?.fillDtTm,
      ReFill_Num: `${readyPickRx?.prescReFill?.reFillNum}`,
      RxDisplayNumber: rxDisplay,
    };
  }

  async getNewErxs(){
      this.newErxsCount = 0;
      this.histPayload = {
        "patientId": this.elinkData?.EntityId,
        "pharmacyNpi": this.elinkParams?.npi
      }
      this.noDataFound = false;
      await this.smsService.getNewErxs(this.histPayload).then(data => {
        if(data && data?.erxDetails?.length > 0){
          const newErxs = data.erxDetails || []; 
          this.newErxsCount = newErxs?.length;
          const combinedData = [...newErxs];           
          this.newPrescription = combinedData.map(this.newErxToCustomObject);
        } else {
          this.noDataFound = true;
          this.newPrescription = [];
        }
    });
  }

  newErxToCustomObject(erxDetails: any): any {
    let erxDetailObj = erxDetails?.eRx;
    let XMLFile = erxDetails?.xmlFile;
    return {
    Receieved_date: XMLFile?.fileDtTm ? XMLFile.fileDtTm : '-',
    Qty: `${erxDetailObj?.quantityValue ? erxDetailObj.quantityValue : '-'}`,
    Days_Supply: `${erxDetailObj?.daysSupply ? erxDetailObj.daysSupply : '-'}`,
    Drug_Name: `${erxDetailObj?.drug ? erxDetailObj.drug : '-'}`,
    Prescriber_name: `${erxDetailObj?.prescLName ? erxDetailObj.prescLName : '-'} ${erxDetailObj?.prescFName ? erxDetailObj.prescFName : '-'}`
    };
  }

  async getRefillsDue(){
      this.refillsDueCount = 0;
      this.histPayload = {
        "patientId": this.elinkData?.EntityId,
        "pharmacyNpi": this.elinkParams?.npi
      }
      this.noDataFound = false;
      await this.smsService.getRefillsDue(this.histPayload).then(data => {
        if(data && data?.refillsDue?.length > 0) {
          const refillsDue = data.refillsDue || []; 
          this.refillsDueCount = refillsDue?.length;
          const combinedData = [...refillsDue];           
          this.refillsDueRxs = combinedData.map(item => this.refillsDueToCustomObject(item));
          this.isAuthorized = true;
          this.sortRefillsDue();
        } else {
          this.noDataFound = true;
          this.isAuthorized = false;
          this.refillsDueRxs = [];
        }
    });
  }
  private sortRefillsDue() {
        this.refillsDueRxs.sort((a, b) => { 
        const dateA = new Date(a.Refil_Due_Date).getTime();
        const dateB = new Date(b.Refil_Due_Date).getTime();

      if (dateA !== dateB) {
          return dateB - dateA; // Descending order
      }

      if (a.status === 'Authorized' && b.status !== 'Authorized') {
          return 1; // Move 'Authorized' to the end
        } else if (b.status === 'Authorized' && a.status !== 'Authorized') {
          return -1; // Move 'Authorized' to the end
        }
          return 0;
      });

      this.refillsDueRxs.sort((a, b) => {
          if (a.status === 'Authorized' && b.status !== 'Authorized') {
            return 1;
          } else if (b.status === 'Authorized' && a.status !== 'Authorized') {
            return -1;
          }
          return 0;
      });
  }

  refillsDueToCustomObject(refillsDue: any): any {

    const authorizedStatus = refillsDue?.prescReFill?.refillQueueStatus === 2 ? 'Authorized' : ''; 
    const deferredStatus = (!refillsDue?.prescReFill?.refillQueueStatus || refillsDue?.prescReFill?.refillQueueStatus === '') && refillsDue?.rxBill?.statusId === 6 ? 'Deferred' : '';
    const status = authorizedStatus;
    const rxDisplay=this.checkIsPartialFill(refillsDue?.prescReFill,refillsDue?.prescription,refillsDue?.rxType)
    ? refillsDue.prescription.prescNum + ' - '+ refillsDue?.prescReFill.reFillNum + ' - ' + refillsDue.prescReFill.partialFillNo
    : refillsDue.prescription.prescNum + ' - '+ refillsDue?.prescReFill.reFillNum;

    return {
      status,
      Rx: `${refillsDue?.prescription?.prescNum}`,
      Qty: `${refillsDue?.prescReFill?.dispQty}`,
      Days_Supply: `${refillsDue?.prescReFill?.supplyDays}`,
      Drug_Name: `${refillsDue?.drug?.drugname} ${refillsDue?.drug?.strength} ${refillsDue?.drug?.drugunit} ${refillsDue?.drug?.drugformname}`,
      Prescriber_name: `${refillsDue?.prescriber?.prescriberlastname} ${refillsDue?.prescriber?.prescriberfirstname}`,
      Refil_Due_Date: `${refillsDue?.rxThreshold}`,
      Refil_Left : `${(refillsDue?.prescReFill?.refillsLeft !== null) ? refillsDue?.prescReFill?.refillsLeft : '--'}`,
      ReFill_Num: `${refillsDue?.prescReFill?.reFillNum}`,
      /* Authorize  data collection */
      PrescrefillId: refillsDue?.prescReFill?.id,
      PrescNum: refillsDue?.prescription?.prescNum,
      RefillNum: refillsDue?.prescReFill?.reFillNum,
      PartialFillNo: refillsDue?.prescReFill?.partialFillNo,
      RxNumber: rxDisplay,
    };
  }

  async authorizeAction(){
      try {
          const checkedItems = this.refillsDueRxs.filter((item) => item.checked) || [];
          if(checkedItems && checkedItems.length > 0) {
              const authorizeToQueue = checkedItems.map(item => ({
                PrescrefillId: item?.PrescrefillId,
                PrescNum: item?.PrescNum,
                RefillNum: item?.RefillNum,
                PartialFillNo: item?.PartialFillNo
              }));
          
              const AddToQueueInputModel = {
                "PatientId": this.elinkData?.EntityId,
                "PharmacyNpi": this.elinkParams?.npi,
                "userId": 0,
                "authorizeToQueue": authorizeToQueue
              }
              await this.smsService.getAddToRefillQueue(AddToQueueInputModel).then(data => {
                if(data){
                  this.getRefillsDue().then(() => {
                      this.updateDashboardCounts();
                      this.stateService.setActiveSection('refillsDue');
                      this.cdr.detectChanges();
                      this.adjustHeight(this.heightRefillsDue);
                  });
                } else {
                  this.handleError(constant.unAuth_Admin_MSG);
                }
            });
          }
      } catch (err) {
          console.error(err);
      }
  }
  checkIsPartialFill(prescReFill: any, _Prescription?: any, rxType?: any) {
        let result = false;
        if ((rxType !== 'rf' &&  prescReFill?.numberOfFills > 1 || (prescReFill?.partialFillNo === 1 && prescReFill?.partialIndStatus === "P"))) {
            result = true;
        }  else if((rxType === 'rf' && prescReFill?.partialFillNo > 1 || (prescReFill?.partialFillNo === 1 && prescReFill?.partialIndStatus === "P"))) {
            result = true;
        }
        return result;
    }
  
  async updateDashboardCounts() {
    // Show cached counts immediately while fresh data loads
    const cached = localStorage.getItem('DboardCounts');
    if (cached) {
      try {
        const cachedCounts = JSON.parse(cached);
        this.dboardCounts = { ...this.dboardCounts, ...cachedCounts };
        this.cdr.detectChanges();
      } catch (e) {}
    }

    const counts = await this.commmonUtil.getCounts();
    if(counts) {
      this.dboardCounts.Pending_Payments = counts.Pending_Payments;
      this.dboardCounts.My_Meds = counts.My_Meds;
      this.dboardCounts.Ready_to_Dispense = counts.Ready_to_Dispense;
      this.dboardCounts.New_Prescription = counts.New_Prescription;
      this.dboardCounts.Refills_Due = counts.Refills_Due;

      // Broadcast to all components (dashboard, etc.) and cache
      this.stateService.setDashboardCounts(this.dboardCounts);
      this.cdr.detectChanges();
    }
  }
  
  calculateDateRange(option: any): { fromDate: any, toDate: any } {
    const toDate = new Date().toISOString();
    let fromDate = new Date();
    if (option === 'Custom Date') {
      if(this.fromDateInput?.nativeElement?.value && this.toDateInput?.nativeElement?.value){
        this.customFromDate = new Date(this.fromDateInput?.nativeElement?.value).toISOString();
        this.customToDate = new Date(this.toDateInput?.nativeElement?.value).toISOString();
        return { fromDate: this.customFromDate, toDate: this.customToDate };
      }
    }
    switch (option) {
      case 'Today': fromDate = new Date();
        break;
      case 'Last One Week':
        fromDate.setDate(fromDate.getDate() - 7);
        break;
      case 'Last 30 Days':
        fromDate.setDate(fromDate.getDate() - 30);
        break;
      case 'Last 60 Days':
        fromDate.setDate(fromDate.getDate() - 60);
        break;
      case 'Last 90 Days':
        fromDate.setDate(fromDate.getDate() - 90);
        break;
      case 'Last 6 Months':
        fromDate.setMonth(fromDate.getMonth() - 6);
        break;
      case 'Last 1 Year':
        fromDate.setFullYear(fromDate.getFullYear() - 1);
        break;
      default:
        fromDate = new Date(0);
    }

    return { fromDate: fromDate.toISOString(), toDate };
  }

  //External Meds Logic

  getPrimeRxUserId(){
    this._peServie.getPrimerxUserId().pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
      if(resp){
        localStorage.setItem('myPrimeRxUserID', resp ? String(resp) : '');
      }
    });
  }
  
  getDrugInfo(term: string): void {
  if (term !== this.currentSearchTerm) {
    this.currentSearchTerm = term;
    this.drugPageNumber = 0;
    this.filterData = [];
    this.hasMoreDrugSuggestions = true;
  }
    if (this.isFetchingDrugs || !this.hasMoreDrugSuggestions) return;
    const payload = {
      "DrugName": term || '',
      "NDC11": '',
       "PageNumber": this.drugPageNumber,
        "PageSize": this.drugPageSize,
        "PharmacyNpi" : this.metaData?.pharmacyNpi,
        AfterKey: this.drugAfterKey
    }
    this._peServie.getDrugInfo(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp) => {
      this.totalDrugCount = resp?.totalCount;
          if (resp?.drugs?.length) {
            this.filterData = [...this.filterData, ...resp.drugs];
            this.enableSuggestions = true;
            this.isDrugNotFound = false;
            this.isFetchingDrugs = false;
            this.drugAfterKey = resp?.nextAfterKey ?? null;
            if (!resp?.drugs?.length || resp?.drugs?.length < this.drugPageSize) {
            this.hasMoreDrugSuggestions = false;
            } else {
            this.hasMoreDrugSuggestions = true;
           }
          }  else {
            this.filterData = [];
            this.enableSuggestions = false;
            this.isDrugNotFound = true;
            this.drugNDC = null;
             this.isFetchingDrugs = false;
             this.drugPageNumber = 0;
          }
        },
        (error) => {
          console.error('Error fetching drug info:', error);
          this.filterData = []; 
        }
    );
  }
  getExternalPharmacyInfo(term : string){
    const payload = {
      organizationName: term
    }
    this._peServie.getExternalPharmacyInfo(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
      if(resp?.length){
        this.filterData = resp;
        this.enableSuggestions = true;
        this.isPharmacyNotFound = false;
      } else {
        this.filterData = [];
        this.enableSuggestions = false;
        this.sourcePharmacyNPI = null;
        this.isPharmacyNotFound = true;
      }
    })
  }


  onSearch(event: any, field: string) {
  const value = (event?.target as HTMLInputElement)?.value;
  if (value && value.trim().length <= 2) {
    this.filterData = [];
    this.enableSuggestions = false;
  }else{
    if (field === 'DrugName') {
      this.drugSearchTerm.next(value);
    } else if (field === 'DispensingPharmacy') {
      this.pharmacySearchTerm.next(value);
    }
  }
  if (!value && field === 'DispensingPharmacy') {
        this.externalRxFG.controls['PharmacyPhone'].setValue('');
        this.externalRxFG.controls['PharmacyPhone'].enable();
      }
}

  addExternalMeds(){
    this.openExtenalMedsPopup = true;
    this.externalRxFG.reset();
  }
  closeExternalMedsPopup(frmHtml: boolean = false){
    this.showDuplicateError = false;
    this.openExtenalMedsPopup = false;
    this.isEditExternalMeds = false;
    this.isTransferInMed = false;
    this.isDeleteExternalMeds = false;
    this.isDrugNotFound = false;
    this.isFillDtExceeded = false;
    this.isPharmacyNotFound = false;
    if(this.sendInitiationSuccess){
      this.sendInitiationSuccess = false;
      this.showSentRequest = true;
    } else {
      this.showSentRequest = false;
    }
    this.externalRxFG.reset();
    this.externalRxFG.enable();
    if(!frmHtml){
      this.getRxHistoryData('onLoad');
    }
    this.updateDashboardCounts();
  }
  getSelectedInformation(event : any, frm?: string){
    const pharmacyInfo = JSON.parse(localStorage.getItem('PharmacyInfo') as string);
    if(frm && frm === "drugName"){
      this.drugNDC = event?.ndc ? event?.ndc : null;
    } 
    if(frm === 'dispensingPharmacy'){
      this.sourcePharmacyNPI = event?.npiNum ? event?.npiNum : null;
      this.externalRxFG.controls['PharmacyPhone'].setValue(event?.phone ? this.commmonUtil.formatPhone(event?.phone) : null);
      event?.phone ? this.externalRxFG.controls["PharmacyPhone"].disable() : '';
    }
    let phones: any = [];
    if(event?.phone) 
      phones.push({Type : 'Phone' , Number: event.phone});
    if(event?.fax) 
      phones.push({Type : 'Fax' , Number: event.fax});
    this.TansferPharmacyFG.patchValue({
      NCPDPID : event?.ncpdpid,
      Npi : event?.npiNum,
      BusinessName: event?.pharmName ? event?.pharmName : null,
      PhoneNumbers: phones?.length ? phones : [],
      Specialty : null,
      Remarks: event?.remarks,
      TenantId : pharmacyInfo?.tenantId,
      tenantNPI : this.elinkParams?.npi,
      Address : {
        AddressLine1: event?.addressLine1 ? event.addressLine1 : null,
        AddressLine2: event?.addressLine2 ? event.addressLine2 : null,
        City: event ? event?.cityName : null,
        State:  event ? event?.stateName : null,
        ZipCode: event ? event?.zipCode : null,
        CountryCode: event ? event?.countryCode : null
      }
    });

  }
  addOrUpdateExternalMeds(){
    if (!this.isTransferInMed && this.isDuplicateExternalRx()) {
    this.showDuplicateError = true;
    return;
  }
  this.showDuplicateError = false;
    const payload = {
      ndcCode : this.drugNDC
    }
    if(this.drugNDC){
      this._peServie.getDrugId(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
      if(resp){
        this.drugId = resp;
        if(!this.enableSuggestions){
            this.saveOrUpdateExternalMeds();
        } else{
          this._peServie.getOrCreateTransferPharmacy(this.TansferPharmacyFG.value).pipe(takeUntil(this.unsubscribe$)).subscribe((res)=>{
          if(res){
              this.saveOrUpdateExternalMeds(res);
          } else {
            this.saveOrUpdateExternalMeds();
          }
        })
        }
      }
    })
    } else{
        if(!this.enableSuggestions){
            this.saveOrUpdateExternalMeds();
        } else{
        this._peServie.getOrCreateTransferPharmacy(this.TansferPharmacyFG.value).pipe(takeUntil(this.unsubscribe$)).subscribe((res)=>{
          if(res){
              this.saveOrUpdateExternalMeds(res);
          } else {
            this.saveOrUpdateExternalMeds(res);
          }
        })
        }
    }
    this.isFrmExternalMeds = true;
  }
normalizePhoneNumber(): void {
    const formattedValue = this.externalRxFG.controls['PharmacyPhone'].value || '';
    const normalizedValue = formattedValue.replace(/\D/g, '');
    this.externalRxFG.controls['PharmacyPhone'].setValue(normalizedValue, { emitEvent: false });
  }
  saveOrUpdateExternalMeds(res?: any){
    this.normalizePhoneNumber()
    const externFG = {
    patientId : this.elinkData?.EntityId,
    prescNum: this.externalRxFG.value.RxNumber ? this.externalRxFG.value.RxNumber : null,
    drugId: this.drugId ? this.drugId : null,
    id : this.externalHistoryId ? this.externalHistoryId : null,
    refillsLeft: this.externalRxFG.value.RefillsLeft ? this.externalRxFG.value.RefillsLeft : null,
    rxExpirationDate: this.normalizeDate(this.externalRxFG.value.ExpirationDate),
    rxOrderedDate: this.normalizeDate(this.externalRxFG.value.OrderDate),
    rxFilledDate: this.normalizeDate(this.externalRxFG.value.FillDate),
    supplyDays: this.externalRxFG.value.SupplyDays ? this.externalRxFG.value.SupplyDays : null,
    dispQty: this.externalRxFG.value.QtyDisp ? this.externalRxFG.value.QtyDisp : null,
    sourcePharmacyName: this.externalRxFG.value.DispensingPharmacy ? this.externalRxFG.value.DispensingPharmacy : null,
    sourcePharmacyNPI: this.sourcePharmacyNPI,
    transferPharmacyId : res?.id ? res?.id : null,
    sourcePharmacyPhoneNumber: this.externalRxFG.getRawValue().PharmacyPhone,
    notes: this.externalRxFG.value.ExternNotes ? this.externalRxFG.value.ExternNotes :  null
  }
  if(!this.isEditExternalMeds && !this.isTransferInMed){
      if(this.externalRxFG.invalid) {
      this.externalRxFG.markAllAsTouched();
      return;
    } else {
      this._peServie.addPatExternalMeds(externFG).pipe(takeUntil(this.unsubscribe$)).subscribe((res)=>{
        if(res){
          this.closeExternalMedsPopup();
          this.updateDashboardCounts();
        }
      })
    }
  } else if(this.isEditExternalMeds && !this.isTransferInMed){
    this._peServie.updatePatExternalMeds(externFG).pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
      if(resp){
        this.closeExternalMedsPopup();
        this.updateDashboardCounts();
      }
    })
  } else{
      this.initiateTransferIn(res);
  }
  }


  initiateTransferIn(res : any){
      const payload = {
        sourcePharmacyName: this.externalRxFG.value.DispensingPharmacy ? this.externalRxFG.value.DispensingPharmacy : null,
        sourcePharmacyPhone: this.externalRxFG.value.PharmacyPhone ? this.externalRxFG.value.PharmacyPhone : null,
        patientId: this.elinkData?.EntityId,
        drugName: this.drugName ? this.drugName : '',
        drugId: this.drugId ? this.drugId : null, 
        externalHistoryId : this.externalHistoryId ? this.externalHistoryId : null,
        transferPharmacyId : res?.id ? res?.id : null,
        SourcePharmacyNPI  : this.transferPharmacyNPI

      }
        this._peServie.getTransferPharmacyElink(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
        if (resp?.message) {
          const linkMessage = resp.message;
          this.sendTransferLink(linkMessage);
          this.sendInitiationSuccess = true;
          this.isTransferInMed = false;
        }
      })
  }
  
  sendTransferLink(message: string) {
  if (message && this.elinkData?.EntityId) {
    this.webPubSubService.sendMessageToPharmacist(this.patientID_npi, message, "")
      .then(() => {
        this.cdr.detectChanges();
        this.ngZone.runOutsideAngular(() => {
          requestAnimationFrame(() => {
          });
        });
      })
      .catch((error) => {
        console.error('Error sending message:', error);
      });
  }
}

  getPatExternalMeds(){
    this._peServie.getPatExteranlMeds(this.elinkData?.EntityId).pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
      if(resp){
        this.externalRxHistory = resp;
      }
    })
  }
  editExternalMeds(item: any, index: any) {
    this.externalRxFG.reset();
    this.isEditExternalMeds = true;
    this.patchValuesAfterEdit(item,'frmEdit');
}
patchValuesAfterEdit(item: any, frm : string){
  const toNgbDateStruct = (dateString: string | null): NgbDateStruct | null => {
  if (!dateString) return null;
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return null;
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  };
    };
    if(frm && frm === "frmTransferIn"){
      this.externalRxFG.disable();
    } else{
      this.externalRxFG.enable();
    }
    this.externalRxFG.patchValue({
        RxNumber: item?.Rx ? item?.Rx:  null,
        DrugName: item?.Drug_Name ? item?.Drug_Name : null,
        RefillsLeft: item?.Refil_Left ? item?.Refil_Left :  null,
       OrderDate: item?.Order_Date ? toNgbDateStruct (item?.Order_Date) : null,
        FillDate: item?.Fill_Date ? toNgbDateStruct (item?.Fill_Date) : null,
        ExpirationDate: item?.Expiration_Date ? toNgbDateStruct (item?.Expiration_Date) : null,
        SupplyDays: item?.Days_Supply,
        QtyDisp: item?.Qty_Disp,
        DispensingPharmacy: item?.Source_PharmacyName ? item?.Source_PharmacyName :  null,
        PharmacyPhone: item?.Source_Pharmacy_PhoneNumber ? this.commmonUtil.formatPhone(item?.Source_Pharmacy_PhoneNumber) : null,
        ExternNotes: item?.Notes ? item?.Notes : null,
    });
    this.enteredPharmacyDetails = this.externalRxFG.value.DispensingPharmacy
    this.drugId = item?.DrugId;
    this.drugName = item?.Drug_Name;
    this.externalHistoryId = item?.externalHistoryId;
    this.transferPharmacyNPI = item?.Source_Pharmacy_NPI
}
  deleteExternalMeds(item : any,index : number){
    this.drugName = item?.Drug_Name ? item?.Drug_Name : null;
    this.isDeleteExternalMeds = true;
    this.isEditExternalMeds = false;
    this.indexToDelete = index;
  }
  confirmToDeleteExternalMeds(){
    const payload = {
      patientId: this.elinkData?.EntityId,
      externalHistoryId: this.indexToDelete ? this.indexToDelete : 0
    }
    this._peServie.deletePatExternalMeds(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
      if(resp){
        this.closeExternalMedsPopup();
        this.isDeleteExternalMeds = false;
        this.drugName = null;
        this.updateDashboardCounts();
      }
    });
  }
  transferInExternMeds(item : any){
    this.isTransferInMed = true;
    this.patchValuesAfterEdit(item,'frmTransferIn');
  }

  onDateChanged(dateStr: string): void {    
    const fillDateStr = this.normalizeDate(this.externalRxFG.value.FillDate);
    const orderDateStr = this.normalizeDate(this.externalRxFG.value.OrderDate);
    const parseDate = (str: string | null) => {
      return str ? new Date(str) : null;
    };
    const fillDate = parseDate(fillDateStr);
    const orderDate = parseDate(orderDateStr);
    this.orderDate = orderDateStr;
    if (fillDate && orderDate && fillDate < orderDate) {
      this.isFillDtExceeded = true;
      this.externalRxFG.get('FillDate')?.reset();
      this.externalRxFG.patchValue({ FillDate: null });
    } else {
      this.isFillDtExceeded = false;
    }
}

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    document.removeEventListener('click', this.boundOnClick);
    if (this.scrollSub) {
      this.scrollSub.unsubscribe();
      this.scrollSub = undefined;
    }
    this.scrollInitialized = false;
  }
  onLoadMoreDrugSuggestions() {
 if (this.latestDrugSearchTerm && this.latestDrugSearchTerm.length > 2) {
    this.getDrugInfo(this.latestDrugSearchTerm);
  }
}
 onInputFocusOut(event: any){
  const currentValue = event;
      const match = this.filterData.some(
        (pharmacy: any) =>
          pharmacy.pharmName === event
      );
      
      
      
      if(!match && (currentValue !==  this.enteredPharmacyDetails)){
        this.isPharmacyNotFound = true;
        this.enableSuggestions = false;
        this.externalRxFG.controls['PharmacyPhone'].setValue('');
        this.externalRxFG.controls['PharmacyPhone'].enable();
      }
}

 normalizeDate = (val: any) => {
  if (!val) return null;
  if (val.year && val.month && val.day) {
    return moment(
      `${String(val.month).padStart(2, '0')}/${String(val.day).padStart(2, '0')}/${val.year}`,
      "MM/DD/YYYY"
    ).format("YYYY-MM-DD");
  }
  if (typeof val === 'string') {
    return moment(val, ["MM/DD/YYYY", "YYYY-MM-DD"], true).isValid()
      ? moment(val, ["MM/DD/YYYY", "YYYY-MM-DD"], true).format("YYYY-MM-DD")
      : null;
  }
  return null;
};

  isDuplicateExternalRx(): boolean {
  const rxNumber = this.externalRxFG.value.RxNumber?.toString().trim();
  const pharmacyName = this.externalRxFG.value.DispensingPharmacy?.toString().trim();
  this.showDuplicateError = false;

  if (!rxNumber || !pharmacyName) return false;

  const allRecords = this.originalRxHistory.flatMap(section => section.records || []);
  return allRecords.some((record: any) => {
    if (!record.isExternalPrescription) return false;

    // Skip same record in edit mode
    if (this.isEditExternalMeds && record.externalHistoryId === this.externalHistoryId) {
      return false;
    }
    return (
      record.Rx?.toString().trim() === rxNumber &&
      record.Source_PharmacyName?.toString().trim().toLowerCase() === pharmacyName.toLowerCase()
    );
  });
  }
}